import { useMutation } from 'react-query';
import { httpService } from '../../../services/http.service';
import { IServerErrorResponse } from '../../../types';

interface IProps {
    authorizedUserId: string;
    customerId: string;
    mfaType: string;
}
export const useResendOtpCode = () => useMutation('', async ({ authorizedUserId, customerId, mfaType }: IProps) => {
  const { data } = await httpService.post(`/api/v3/onboarding/user/${customerId}/authorized/user/${authorizedUserId}/sendOtp`, { mfaType });
  return data;
}, {
  onError: (e: IServerErrorResponse) => {
    console.log(e);
  },
});
